
<template>

  <ion-content class="d-flex wrapper" v-if="isMobile">
    <NavBar />
      <div class="block block__resume">
          <transition  
            name="fade"
          >
            <router-view></router-view>
          </transition>
      </div>
  </ion-content> 


  <section class="d-flex wrapper" v-else>
      <SidebarMain class="desktop" />
      <div class="block block__resume">
          <transition  
            name="fade"
          >
            <router-view></router-view>
          </transition>
      </div>
  </section> 





</template>

<script>
import SidebarMain from '../../module/sidebar/SidebarMain'
import CatMixin from './CatMixin'
import { mapGetters } from 'vuex'
import NavBar from '../../module/Navbar'

export default {
  name:"resume",
  components:{
      SidebarMain,
      NavBar
  }, 
  mixins: [
    CatMixin
  ],        
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'getPageTransition',
    ])
  },
  methods : {
  afterEnter: () => {
    // window.scrollTo(0, 0);
  },     
  afterLeave: function (){
      this.$store.dispatch('setDefaultTransition');
    },
  beforeEnter: function (){
    }
  },
  watch: {
    getPageTransition() {
      this.transition = this.getPageTransition;
    },
  } 
};
</script>
